<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add @click="toAddPage" v-if="permissionCodes.indexOf('014002001') !== -1" />
      </div>
        <div>
          <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">缴费时间</span>
          <el-date-picker v-model="timevalue" size="small" type="datetimerange" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期"
                          align="right" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
      <div style="display: flex;justify-content: space-between;">
        <input-search placeholder="收费项名称/缴费主体/所属住户/手机号" @search="searchKey" />
        <button-export
          style="margin-left: 5px"
          :href="exportUrl"
          download="download.xls"
          v-if="permissionCodes.indexOf('014003003') !== -1"
          :beforeDownload="beforeDownload"
          value="导出"/>
      </div>
    </div>
    <table-main :hasOperation="false" :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @goToModifyPage="goToModifyPage" @deleteLine="deleteLine" deleteTipInfo="是否确认删除该缴费项？"  :cathUrl="uploadUrl" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/CustomPayment";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "pay-record",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧收费",
          name: "charge-items-management"
        },
        {
          value: "收费管理"
        }
      ],
      exportUrl: "",
      addPageName: "charge-management-add",
      tableHead: [
        {
          prop: "paymentItemName",
          label: "收费项名称"
        },
        {
          prop: "chargeMode",
          label: "收费模式"
        },
        {
          prop: "chargeType",
          label: "收费类型"
        },
        {
          prop: "payMethodText",
          label: "收款方式"
        },
        {
          prop: "chargeAmount",
          label: "收费金额(元)"
        },
        {
          prop: "payer",
          label: "缴费主体"
        },
        {
          prop: "enterpriseName",
          label: "所属住户"
        },
        {
          prop: "roomNumber",
          label: "房间号"
        },
        {
          prop: "phone",
          label: "手机号"
        },
        {
          prop: "billStatusText",
          label: "账单状态"
        },
        {
          prop: "payTime",
          label: "缴费时间"
        },
        {
          prop: "refundTime",
          label: "退款时间"
        },
        {
          prop: "memo",
          label: "备注"
        }
      ],
      operationArr: ["modify", "delete"],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      uploadUrl: "",
      selectionArr: [],
      requestData: {
        searchKey: ""
      },
      timevalue: []
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.uploadUrl = api.importPaymentItemBill;
    this.getCreateTime();
  },
  activated() {
    this.getCreateTime();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportCharge}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&startTime=${this.requestData.startTime}&endTime=${
        this.requestData.endTime
      }`;
    },
    toAddPage() {
      this.$router.push({
        name: "charge-management-add"
      });
    },
    goToModifyPage(code) {
      this.$router.push({
        path: "/custom_payment_bill_modify/" + code
      });
    },
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0];
        this.requestData.endTime = this.timevalue[1];
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }

      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getChargeBillPage, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {
              if (v.billStatus === "0") {
                v.billStatusText = "未付款";
              } else if (v.billStatus === "1") {
                v.billStatusText = "已付款";
              } else if (v.billStatus === "2") {
                v.billStatusText = "已退款";
              }
              if (v.payMethod === "1") {
                v.payMethodText = "微信";
              } else if (v.payMethod === "2") {
                v.payMethodText = "支付宝";
              } else if (v.payMethod === "3") {
                v.payMethodText = "银行转账";
              } else if (v.payMethod === "4") {
                v.payMethodText = "现金";
              } else if (v.payMethod === "5") {
                v.payMethodText = "其他";
              }
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    getCreateTime() {
      this.timevalue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timevalue[0] = year + "-" + month + "-" + date + " " + "00:00:00";
      this.timevalue[1] = year + "-" + month + "-" + date + " " + "23:59:59";
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    deleteLine(code) {
      let codeStr = code.join("");
      this.$axios
        .post(api.deletePaymentItem, {
          code: codeStr
        })
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    }
  },
  watch: {
    timevalue(val) {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/CustomPayment/ChargeManagement/ChargeManagement.vue